var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ml-3 SlcSelectionControls-cancelButton",on:{"click":function($event){$event.stopPropagation();return _vm.clearSelection.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.$t("cancel"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }